import { AlertCircle } from 'lucide-react';
import MaquetteWorkspace from './MaquetteWorkspace';
import ProjectGallerySection from './ProjectGallerySection';

/**
 * ProductionSection — V17.0 : Préparation (traçage) · Génération (rendus, shoebox, perspectives) · Galerie (visuels validés).
 * `focus` = { lotId, buildingId } posé par le Dashboard ; les deep-links ?lot_id= / ?building_id= sont lus par MaquetteWorkspace.
 */
export default function ProductionSection({ projectId, project, tab, hasPending, focus, onOpen, onPlanVente, onRapport }) {
  return (
    <div className="space-y-3" data-testid={`production-${tab}`}>
      {hasPending && tab === 'generation' && (
        <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3" data-testid="production-pending-banner">
          <AlertCircle className="w-4 h-4 text-amber-600 mt-0.5 shrink-0" />
          <p className="text-[12px] text-amber-900">Le CCTP analysé n'est pas encore intégré au prompt : les générations utilisent l'ancienne configuration jusqu'à validation dans la Matériauthèque.</p>
        </div>
      )}
      {tab === 'preparation' && <MaquetteWorkspace key="prep" projectId={projectId} project={project} phase="preparation" onOpenGeneration={(lotId) => onOpen('production', 'generation', { lotId })} />}
      {tab === 'generation' && <MaquetteWorkspace key="gen" projectId={projectId} project={project} phase="generation" onOpenPreparation={(lotId) => onOpen('production', 'preparation', { lotId })} />}
      {tab === 'galerie' && <ProjectGallerySection projectId={projectId} onPlanVente={onPlanVente} onRapport={onRapport} focus={focus} />}
    </div>
  );
}
